var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"ten-fade-in"}},[(_vm._finishVisible)?_c('div',{staticClass:"ten-backtop",style:({
      right: _vm._offsetRight,
      bottom: _vm._offsetBottom
    }),on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_c('ten-button',{staticClass:"ten-backtop-button",attrs:{"theme":"default","icon":"backtop","round":"","icon-only":""}})]})],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }